import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../styles/Mechhero.css';
import img1 from '../assets/mc-10.webp';
import img2 from '../assets/mc6.jpg';
import img3 from '../assets/mc-13.png';
import img4 from '../assets/mc-9.webp';
import img5 from '../assets/mc-11.jpg';

const Mechhero = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="mechhero-container">
      <div className="mechhero-row">
        <div className="mechhero-box" data-aos="fade-right" data-aos-delay="0">
          <img src={img1} alt="Mechanical Design 1" />
        </div>
        <div className="mechhero-box" data-aos="fade-up" data-aos-delay="100">
          <h3>HVAC System Layouts</h3>
          <p>
            Our HVAC System Layout services provide efficient, code-compliant designs that optimize comfort, airflow, and energy performance for any building type. We specialize in creating detailed, accurate HVAC layouts that integrate seamlessly with architectural and structural plans. From residential developments to large-scale commercial projects, our experienced team ensures your heating, ventilation, and air conditioning systems are strategically designed for maximum efficiency, ease of installation, and long-term reliability.
          </p>
        </div>
        <div className="mechhero-box" data-aos="fade-left" data-aos-delay="200">
          <img src={img2} alt="Mechanical Design 2" />
        </div>
      </div>

      <div className="mechhero-row">
        <div className="mechhero-box" data-aos="fade-right" data-aos-delay="0">
          <h3>HVAC CAD Design Services</h3>
          <p>
           Our Mechanical AutoCAD Design services provide precise, high-quality drafting solutions for HVAC, plumbing, fire protection, and other mechanical systems. Leveraging industry-standard AutoCAD software, we produce detailed 2D and 3D drawings that support efficient fabrication, installation, and project coordination. Our designs are tailored to meet project specifications, local codes, and engineering standards, ensuring accuracy and constructability. Whether for new construction or retrofit projects, we collaborate closely with engineers, architects, and contractors to deliver clear, optimized mechanical layouts that drive project success.
          </p>
        </div>
        <div className="mechhero-box res-box" data-aos="fade-up" data-aos-delay="100">
          <img src={img3} alt="HVAC Layout" />
        </div>
        <div className="mechhero-box" data-aos="fade-left" data-aos-delay="200">
          <h3>HVAC Execution</h3>
          <p>
           Our Mechanical HVAC Execution services deliver end-to-end solutions tailored to your project's unique requirements. From initial concept and detailed system design to installation and commissioning, we ensure every phase is executed with precision and efficiency. Our team combines technical expertise with the latest industry standards to create HVAC systems that maximize energy efficiency, indoor air quality, and long-term reliability. Whether it's a new build or a retrofit, we coordinate seamlessly with architects, engineers, and contractors to bring your mechanical systems to life—on time, on budget, and built to perform.


          </p>
        </div>
      </div>

      <div className="mechhero-row">
        <div className="mechhero-box" data-aos="fade-right" data-aos-delay="0">
          <img src={img4} alt="Piping Design" />
        </div>
        <div className="mechhero-box" data-aos="fade-up" data-aos-delay="100">
          <h3>HVAC Consultation</h3>
          <p>
           Our HVAC Consultation service is designed to provide expert guidance on heating, ventilation, and air conditioning systems for residential, commercial, and industrial projects. Whether you're planning a new installation, upgrading existing systems, or troubleshooting performance issues, our consultants bring in-depth knowledge and practical insights to optimize system design, performance, and longevity. We ensure that every recommendation supports comfort, sustainability, and long-term value.
          </p>
        </div>
        <div className="mechhero-box" data-aos="fade-left" data-aos-delay="200">
          <img src={img5} alt="3D Design" />
        </div>
      </div>
    </div>
  );
};

export default Mechhero;
